<script setup>
// core
import {computed} from "vue";
import {useI18n} from "vue-i18n";

const {t: $t} = useI18n()

const props = defineProps({
    status: {
        type: String,
        default: ''
    }
})

// everything but an activated number falls back to "requires activation"
const statusKey = computed(() =>
    props.status === 'Activated' ? 'active' : 'requires_activation'
)

const displayedStatus = computed(() =>
    $t(`telephony.connected_numbers.status.${statusKey.value}`)
)
</script>

<template>
    <div class="status" :class="statusKey">
        <button class="text-uppercase" style="text-wrap: balance">
            {{ displayedStatus }}
        </button>
    </div>
</template>

<style scoped lang="scss">
@use "@/styles/table.scss";
</style>
